// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"165":"4f23e397969f69757dbf","888":"6f03dfdd17a7f35d3a38"}[chunkId] + ".css";
};